<template>
    <div class="product-tab-content">

        <p>
            <span v-if="!comparisonStore.location || !comparisonStore.location.postCode">
                Dit internetabonnement biedt
                <span v-if="product.internet.connection === 'dsl'">internet via de telefoonlijn (DSL).</span>
                <span v-if="product.internet.connection === 'cable'">snel internet via de tv-kabel (coax).</span>
                <span v-if="product.internet.connection === 'fiber'">erg snel internet via glasvezel.</span>
                <span v-if="product.internet.connection === '5g'">snel internet via het mobiele 5G-netwerk. Goed bereik
                    is
                    wel
                    belangrijk voor een stabiele en snelle verbinding.</span>
                <span v-if="product.internet.connection === '4g'">internet via het mobiele 4G-netwerk. Goed bereik is
                    wel
                    belangrijk voor een stabiele en snelle verbinding.</span>
            </span>

            <span v-if="comparisonStore.location && comparisonStore.location.postCode">
                Aan de hand van je adres hebben we gekeken wat de hoogst haalbare downloadsnelheid is voor jouw adres.
                Dit is <strong>{{ product.internet.speed_down_expected }} Mb/s</strong> van de
                {{ product.internet.speed_down }} Mb/s die maximaal in dit pakket zit.
            </span>
        </p>

        <product-info-table :rows="internetRows">
            <template v-slot:row-network>
                <product-info-property icon="x-fa-globe" v-if="product.internet.connection === 'dsl'">
                    Internet via ADSL
                </product-info-property>
                <product-info-property icon="x-fa-globe" v-if="product.internet.connection === 'cable'">
                    Snel internet via kabel
                </product-info-property>
                <product-info-property icon="x-fa-globe" v-if="product.internet.connection === 'fiber'">
                    Zeer snel internet via glasvezel
                </product-info-property>
                <product-info-property icon="x-fa-globe" v-if="product.internet.connection === '5g'">
                    Snel internet via het 5G-netwerk
                </product-info-property>

                <product-info-property icon="x-fa-download"
                    v-if="!product.internet.speed_down_expected || product.internet.speed_down_expected === product.internet.speed_down">
                    {{ product.internet.speed_down }} Mb/s download
                </product-info-property>
                <product-info-property icon="x-fa-download"
                    v-if="product.internet.speed_down_expected && product.internet.speed_down_expected !== product.internet.speed_down">
                    <strong>{{ product.internet.speed_down_expected }}</strong> van {{ product.internet.speed_down }}
                    Mb/s
                    op
                    jouw adres
                </product-info-property>
                <product-info-property icon="x-fa-upload">
                    {{ product.internet.speed_up }} Mb/s upload
                </product-info-property>
            </template>

            <template v-slot:row-included>
                <product-info-property icon="x-fa-plus" v-if="product.internet.extra.hotspots">
                    Gratis wifi hotspots
                </product-info-property>
                <product-info-property icon="x-fa-signal-stream" v-if="product.internet.extra.wifi_repeater">
                    Gratis wifi versterker
                </product-info-property>
                <product-info-property icon="x-fa-shield-check" v-if="product.internet.extra.security">
                    Gratis beveiligingspakket
                </product-info-property>

                <product-info-property icon="x-fa-info" v-if="product.installation_support === 'optional'">
                    Monteur als het niet zelf lukt
                </product-info-property>
                <product-info-property icon="x-fa-person-dolly" v-if="product.installation_support === 'included'">
                    Inclusief gratis monteur
                </product-info-property>
                <product-info-property icon="x-fa-info"
                    v-if="product.installation_support !== 'optional' && product.installation_support !== 'included'">
                    Stap-voor-stap installatiepakket
                </product-info-property>
            </template>

            <template v-slot:row-phone>
                <product-info-property icon="phone">
                    {{ toCurrencyEur(product.phone.tariff_minute_fixed) }} naar vaste nummers
                </product-info-property>
                <product-info-property icon="phone" v-if="product.phone.tariff_minute_mobile">
                    {{ toCurrencyEur(product.phone.tariff_minute_mobile) }} naar mobiel
                </product-info-property>
                <product-info-property icon="phone" v-if="product.phone.tariff_start">
                    {{ toCurrencyEur(product.phone.tariff_start) }} starttarief
                </product-info-property>
                <product-info-property icon="x-fa-info" v-if="product.phone.number_retention">
                    Inclusief gratis nummerbehoud
                </product-info-property>
            </template>
        </product-info-table>
    </div>

</template>


<script setup>
import { computed } from 'vue';
import ProductInfoTable from 'vue-elements/product-info/ProductInfoTable.vue';
import ProductInfoProperty from 'vue-elements/product-info/ProductInfoProperty.vue';
import { useInternetComparisonStore } from '../../stores/internetComparison';


const comparisonStore = useInternetComparisonStore();

const props = defineProps({
    product: Object,
});
const internetRows = computed(() => {
    let rows = [
        {
            id: 'network',
            label: 'Internet',
        },
        {
            id: 'included',
            label: 'Inbegrepen',
        }
    ];

    if (props.product.phone.included) {
        rows.push({
            id: 'phone',
            label: 'Vaste telefoon',
        });
    }

    return rows;
});
</script>